import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

const styles = () =>
	({
		root: {
			zIndex: 2000,
			position: 'absolute',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '100%',
			height: '100%',
			backgroundColor: 'var(--grey_200)',
			opacity: 0.7,
			top: 0,
			left: 0
		}
	});

const LoadingView = (props) =>
{
	const { classes } = props;

	return (
		<div className={classes.root} >
			<CircularProgress/>
		</div>
	);
};

LoadingView.propTypes =
{
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LoadingView);